import { render, staticRenderFns } from "./GideEventList.vue?vue&type=template&id=0397ffa2&scoped=true"
import script from "./GideEventList.vue?vue&type=script&lang=js"
export * from "./GideEventList.vue?vue&type=script&lang=js"
import style0 from "./GideEventList.vue?vue&type=style&index=0&id=0397ffa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0397ffa2",
  null
  
)

export default component.exports